export default "__VITE_ASSET__5185ecc9__"